import { LOCATION } from "../_constants/actionConstants";
import axios from "axios";
import qs from "qs";
import { BASE_URL } from "../_constants/urlConstants";
import { getUUID } from "../_utils/generalUtils";
import { actionScripts } from "../_helpers/actionScripts";

const add = (newLocationData) => async (dispatch) => {
  dispatch({ type: LOCATION.ADD });
  const apiEndpoint = BASE_URL + "/api/Locations/Add";
  try {
    const res = await axios.post(apiEndpoint, newLocationData);
    dispatch({
      type: LOCATION.ADD_FULFILLED,
      projLocationList: res.data.projLocationList,
      projectId: newLocationData.projectId,
    });
    return res.data.newLocationId;
  } catch (err) {
    const errorId = getUUID();
    const type = LOCATION.ADD_REJECTED;
    const newError = { errorId, type, error: err.response.data };
    actionScripts.ADD_ERROR.run(newError);
    console.log(LOCATION.ADD_REJECTED, err.response.data);
  }
};

const update = (locationData) => async (dispatch) => {
  dispatch({ type: LOCATION.EDIT });
  const apiEndpoint = BASE_URL + "/api/Locations/Update";
  try {
    const res = await axios.post(apiEndpoint, locationData);
    dispatch({
      type: LOCATION.EDIT_FULFILLED,
      projLocationList: res.data.projLocationList,
      locationDetails: res.data.locationDetails,
      projectId: locationData.projectId,
      locationId: locationData.locationId,
    });
    return;
  } catch (err) {
    const errorId = getUUID();
    const type = LOCATION.EDIT_FULFILLED;
    const newError = { errorId, type, error: err.response.data };
    actionScripts.ADD_ERROR.run(newError);
    console.log(LOCATION.EDIT_FULFILLED, err.response.data);
  }
};

const deleteLocation = (locationId, projectId) => async (dispatch) => {
  dispatch({ type: LOCATION.DELETE });
  const apiEndpoint = BASE_URL + "/api/Locations/Delete";
  try {
    const res = await axios.delete(apiEndpoint, {
      params: { locationId, projectId },
      paramsSerializer: (params) => qs.stringify(params),
    });
    dispatch({
      type: LOCATION.DELETE_FULFILLED,
      projLocationList: res.data.projLocationList,
      projectId,
      locationId,
    });
    dispatch({ type: LOCATION.CLEAR_DETAILS, projectId, locationId });
    return;
  } catch (err) {
    const errorId = getUUID();
    const type = LOCATION.DELETE_REJECTED;
    const newError = { errorId, type, error: err.response.data };
    actionScripts.ADD_ERROR.run(newError);
    console.log(LOCATION.DELETE_REJECTED, err.response.data);
  }
};

const getDetails = (locId, projectId) => async (dispatch) => {
  dispatch({ type: LOCATION.FETCH_DETAILS });
  const apiEndpoint = BASE_URL + "/api/Locations/GetDetails/?locId=" + locId;
  try {
    const res = await axios.get(apiEndpoint);
    console.log("details", res.data);
    console.log("details params:", locId, projectId);
    dispatch({
      type: LOCATION.FETCH_DETAILS_FULFILLED,
      locationId: locId,
      projectId,
      payload: res.data,
    });
    return;
  } catch (err) {
    const errorId = getUUID();
    const type = LOCATION.FETCH_DETAILS_REJECTED;
    const newError = { errorId, type, error: err.response.data };
    actionScripts.ADD_ERROR.run(newError);
  }
};

const getAll = (projId) => async (dispatch) => {
  dispatch({ type: LOCATION.FETCH_ALL });
  const apiEndpoint = BASE_URL + "/api/Locations/GetProjectLocations/?projId=" + projId;
  try {
    const res = await axios.get(apiEndpoint);
    dispatch({
      type: LOCATION.FETCH_ALL_FULFILLED,
      projectId: projId,
      projLocationList: res.data,
    });
    return;
  } catch (err) {
    const errorId = getUUID();
    const type = LOCATION.FETCH_ALL_REJECTED;
    const newError = { errorId, type, error: err.response.data };
    actionScripts.ADD_ERROR.run(newError);
  }
};

const exists = (projectId, name) => async (dispatch) => {
  dispatch({ type: LOCATION.GENERIC_REQUEST });
  const apiEndpoint = BASE_URL + "/api/Locations/Exists";
  try {
    const res = await axios.get(apiEndpoint, { params: { projectId, name } });
    dispatch({ type: LOCATION.GENERIC_REQUEST_FULFILLED });
    return res.data;
  } catch (err) {
    const errorId = getUUID();
    const type = LOCATION.GENERIC_REQUEST_REJECTED;
    const newError = { errorId, type, error: err.response.data };
    actionScripts.ADD_ERROR.run(newError);
    console.log(LOCATION.GENERIC_REQUEST_REJECTED, err.response.data);
  }
};

const getAllIdsWithLinks = (bidItemId) => async (dispatch) => {
  dispatch({ type: LOCATION.GENERIC_REQUEST });
  const apiEndpoint =
    BASE_URL + "/api/Locations/GetAllIdsWithLinks/?bidItemId=" + bidItemId;
  try {
    const res = await axios.get(apiEndpoint);
    dispatch({ type: LOCATION.GENERIC_REQUEST_FULFILLED });
    return res.data;
  } catch (err) {
    const errorId = getUUID();
    const type = LOCATION.GENERIC_REQUEST_REJECTED;
    const newError = { errorId, type, error: err.response.data };
    actionScripts.ADD_ERROR.run(newError);
  }
};

const hasLinks = (locId) => async (dispatch) => {
  dispatch({ type: LOCATION.GENERIC_REQUEST });
  const apiEndpoint = BASE_URL + "/api/Locations/HasLinks/?locId=" + locId;
  try {
    const res = await axios.get(apiEndpoint);
    dispatch({ type: LOCATION.GENERIC_REQUEST_FULFILLED });
    return res.data;
  } catch (err) {
    const errorId = getUUID();
    const type = LOCATION.GENERIC_REQUEST_REJECTED;
    const newError = { errorId, type, error: err.response.data };
    actionScripts.ADD_ERROR.run(newError);
    console.log(LOCATION.GENERIC_REQUEST_REJECTED, err.response.data);
  }
};

const validateGenericLocations = (projectId) => async (dispatch) => {
  dispatch({ type: LOCATION.VALIDATE_GENLOCS });
  const apiEndpoint =
    BASE_URL + "/api/Locations/ValidateGenericLocations/?projectId=" + projectId;
  try {
    const res = await axios.get(apiEndpoint);
    dispatch({ type: LOCATION.VALIDATE_GENLOCS_FULFILLED });
    return;
  } catch (err) {
    const errorId = getUUID();
    const type = LOCATION.VALIDATE_GENLOCS_REJECTED;
    const newError = { errorId, type, error: err.response.data };
    actionScripts.ADD_ERROR.run(newError);
    console.log(LOCATION.VALIDATE_GENLOCS_REJECTED, err.response.data);
  }
};

const locationActions = {
  add,
  update,
  deleteLocation,
  getAll,
  getAllIdsWithLinks,
  getDetails,
  exists,
  hasLinks,
  validateGenericLocations,
};

export default locationActions;
